import React, { useEffect, useContext, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import sandGlassImg from '../assets/images/bigSandGlass.png';
import Layout from '../components/common/Layout';
import TenantConfig from '../config';
import { UserContext } from '../context/UserContext';
import { getApplicationId } from '../helpers/applicationHelp';

/** helpers */
import { formatUSDCurrency } from '../helpers/format';
import { getApplication } from '../service/api';

const ReviewInProgressPage = () => {
  const navigate = useNavigate();
  const { appData, updateAppData, profile } = useContext(UserContext);
  const [offerProperty, setOfferProperty] = useState({});
  const timeout = 1000 * 5;

  useEffect(() => {
    const timer = setInterval(async () => {
      const res = await getApplication();
      const lOfferProperty = res.data.applicationFeatures.find(
        (feature) => feature.itemType === 'OfferProperty'
      ).value;
      setOfferProperty(lOfferProperty);
      if (res && res.data) {
        updateAppData(res.data);
      }
    }, timeout);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async () => {
    return navigate('/dashboard');
  };

  return (
    <Layout>
      <div className="need-docs">
        <div className="need-docs-header">
          <h1 className="title">We are looking it over</h1>
          {TenantConfig.isAmazonLayout() ? (
            <h3 className="subtitle">
              {profile.firstName}, thank you for submitting your application. <br />
              We are carefully reviewing your application. <br /> We appreciate your patience.
            </h3>
          ) : (
            <h3 className="subtitle">
              Thank you for submitting your application. <br />
              We are carefully reviewing your application. <br /> We appreciate your patience.
            </h3>
          )}
        </div>
        <div className="d-flex app-info">
          <div className="d-flex">
            <div className="app-number-text">
              <h3>Application Number: {getApplicationId(appData, false)}</h3>
              {TenantConfig?.reviewInProgress.renderAppNumberDescription &&
                offerProperty &&
                offerProperty.maxAmount && (
                  <p className="description">
                    {offerProperty.minApr === offerProperty.maxApr
                      ? offerProperty.minApr
                      : `${offerProperty.minApr} - ${offerProperty.maxApr}`}{' '}
                    % APR up to {formatUSDCurrency(offerProperty.maxAmount)} over{' '}
                    {offerProperty.loanTerm} months.
                  </p>
                )}
            </div>
          </div>
          <div className="status">
            <img src={sandGlassImg} alt="" />
            {TenantConfig?.reviewInProgress.showPendingText && <p>PENDING</p>}
          </div>
        </div>
        <div className={TenantConfig?.reviewInProgress.mainClassName}>
          <h1 className="title">What happens next?</h1>
          <h3 className="subtitle">{TenantConfig?.reviewInProgress?.subTitle}</h3>
        </div>
        {TenantConfig?.reviewInProgress.renderBelowSection && (
          <div className="need-docs-header">
            <h1 className="title">What Should You do?</h1>
            <h3 className="subtitle">
              Check your email for notification about your selection decision. You will be either
              selected, waitlisted, or not selected to move forward in the application process.
            </h3>
          </div>
        )}
        <div className="actions">
          <button className="primary-btn" onClick={handleSubmit}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default ReviewInProgressPage;
